import { DestinationEvent } from '@eventbrite/event-renderer';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';
import { NearbyPOIShape } from '../../../../types/AppProps';
import { PointOfInterest } from '../../PointOfInterestPage';
import { FAQItem, SectionData } from './FAQItem';
import styles from './faqs.module.scss';
import { FAQS_ENUM, getFAQs } from './utils/getFAQs';

export interface PointsOfInterestFAQProps {
    pointOfInterestName: PointOfInterest['pointOfInterestName'];
    hoursOfOperation: PointOfInterest['hoursOfOperation'];
    nearbyPointsOfInterest: Array<NearbyPOIShape>;
    nearbyEvents: Array<DestinationEvent>;
}

type Question = {
    answerText: GenericLazyString;
    questionText: GenericLazyString;
    sectionData?: Array<SectionData>;
};

const FAQHeader = ({ text }: { text: GenericLazyString }) => {
    return (
        <h2 className={styles.header}>
            <p className="eds-text-hs">{text}</p>
        </h2>
    );
};

export const PointsOfInterestFAQs = ({
    pointOfInterestName,
    hoursOfOperation,
    nearbyPointsOfInterest,
    nearbyEvents,
}: PointsOfInterestFAQProps) => {
    // TODO: @apean-eb Add FF logic here. Need to decide on Split vs Statsig
    const headerText = gettext(
        'Frequently asked questions about the %(pointOfInterest)s',
        { pointOfInterest: pointOfInterestName },
    );

    const questions: Question[] = getFAQs({
        data: {
            hoursOfOperation,
            pointOfInterestName,
            nearbyPointsOfInterest,
            nearbyEvents,
        },
        faqs: [
            FAQS_ENUM.FAQ_HOURS_OF_OPERATION,
            FAQS_ENUM.FAQ_POPULAR_EVENTS,
            FAQS_ENUM.FAQ_NEARBY_POI,
        ],
    });

    const SHOW_FAQ_SECTION = questions.length > 0;

    return SHOW_FAQ_SECTION ? (
        <section
            className={styles.faqSection}
            itemScope
            itemType="https://schema.org/FAQPage"
        >
            <FAQHeader text={headerText} />
            <div className={styles.faqContainer}>
                {questions.map(({ questionText, answerText, sectionData }) => (
                    <FAQItem
                        key={questionText.toString()}
                        questionText={questionText}
                        answerText={answerText}
                        sectionData={sectionData}
                    />
                ))}
            </div>
        </section>
    ) : null;
};
